import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { DirectiveModule } from '@fcom/common/directives';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { ServiceFormsModule } from '@fcom/service-forms';
import { CommonServiceFormsModule } from '@fcom/service-forms/components/common/common-service-forms.module';
import { ProfileModule } from '@fcom/loyalty-profile';
import { CmsModule } from '@fcom/cms/components';
import { LoyaltyCoreModule } from '@fcom/loyalty-core';
import { LocalizationProvider } from '@fcom/core/services/language/localization.provider';
import { I18nKey } from '@fcom/core';

import { PlusRouteModule } from './plus.routes';
import { PlusDashboardComponent } from './views/plus-dashboard/plus-dashboard.component';
import { PlusProfileComponent } from './views/plus-profile/plus-profile.component';
import { BalanceAndTransactionsComponent } from './views/balance-and-transactions/balance-and-transactions.component';
import { TierProgressAndBenefitsComponent } from './views/tier-progress-and-benefits/tier-progress-and-benefits.component';
import { BuyPointsComponent } from './views/buy-points/buy-points.component';
import { UpgradeTravelClassComponent } from './views/upgrade-travel-class/upgrade-travel-class.component';
import { CampaignEnrollComponent } from './views/campaign-enroll/campaign-enroll.component';
import { GuardianInformationFormComponent } from './components/guardian-information-form/guardian-information-form.component';
import { PointsBalanceComponent } from './components/points-balance/points-balance.component';
import { TierProgressComponent } from './components/tier-progress/tier-progress.component';
import { PlusDashboardHeaderComponent } from './components/plus-dashboard-header/plus-dashboard-header.component';
import { TransactionHistoryComponent } from './components/transaction-history/transaction-history.component';
import { UpgradeAvailabilityComponent } from './components/upgrade-availability/upgrade-availability.component';
import { ExpiringVoucherNotificationComponent } from './components/expiring-voucher-notification/expiring-voucher-notification.component';
import { UpgradeBenefitsComponent } from './components/upgrade-benefits/upgrade-benefits.component';
import { NewMemberNotificationComponent } from './components/new-member-notification/new-member-notification.component';
import { TransactionService } from './services/transaction.service';
import { VoucherService } from './services/voucher.service';
import { UpgradeAvailabilityService } from './services/upgrade-availability.service';
import { CampaignService } from './services/campaign.service';
import { AviosLinkingService } from './services/avios-linking.service';
import { MilestonesComponent } from './components/milestones/milestones.component';
import { MilestoneComponent } from './components/milestone/milestone.component';
import { TierBenefitsComponent } from './components/tier-benefits/tier-benefits.component';
import { BenefitBannerComponent } from './components/benefit-banner/benefit-banner.component';
import { PromotionSegmentComponent } from './components/promotion-segment/promotion-segment.component';
import { AviosLinkingAndExchangeComponent } from './components/avios-linking-and-exchange/avios-linking-and-exchange.component';

@NgModule({
  imports: [
    PlusRouteModule,
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    GtmModule,
    PipesModule,
    CommonServiceFormsModule,
    ServiceFormsModule,
    ProfileModule,
    ReactiveFormsModule.withConfig({
      callSetDisabledState: 'whenDisabledForLegacyCode',
    }),
    UiTranslateModule,
    UiComponentsModule,
    CmsModule,
    LoyaltyCoreModule,
  ],
  declarations: [
    PlusDashboardComponent,
    PlusProfileComponent,
    GuardianInformationFormComponent,
    PointsBalanceComponent,
    TierProgressComponent,
    PlusDashboardHeaderComponent,
    BalanceAndTransactionsComponent,
    TransactionHistoryComponent,
    ExpiringVoucherNotificationComponent,
    UpgradeBenefitsComponent,
    TierProgressAndBenefitsComponent,
    NewMemberNotificationComponent,
    BuyPointsComponent,
    UpgradeTravelClassComponent,
    UpgradeAvailabilityComponent,
    CampaignEnrollComponent,
    MilestonesComponent,
    MilestoneComponent,
    TierBenefitsComponent,
    BenefitBannerComponent,
    PromotionSegmentComponent,
    AviosLinkingAndExchangeComponent,
  ],
  exports: [],
  providers: [TransactionService, VoucherService, UpgradeAvailabilityService, CampaignService, AviosLinkingService],
})
export class PlusModule {
  constructor(private localizationProvider: LocalizationProvider) {
    this.localizationProvider.triggerLazyLocalizations(I18nKey.LOYALTY);
  }
}
